<div class="strategy-wrapper">
  <ng-container *ngIf="strategyInfoLoaded$ | async; else loadingState">
    <div data-cy="strategy-portfolio">
      <div class="intro-title">
        <ng-container *ngIf="step === 5; else onboarding">
          <h1 class="ui-headline">{{ 'new_strategy.portfolio_screen.h2' | translate }}</h1>
        </ng-container>
        <ng-template #onboarding>
          <h1 class="ui-headline">{{ 'new_strategy.portfolio_screen.h2' | translate }}</h1>
          <p>{{ 'new_strategy.portfolio_screen.p' | translate }}</p>
        </ng-template>
      </div>
    </div>

    @if (showEve2Callout$ | async) {
      <app-ds-callout
        variant="info"
        [title]="'PERFORMANCE.contentSwitcher.strategy.migration.title' | translate"
        [description]="'PERFORMANCE.contentSwitcher.strategy.migration.desc' | translate"
      ></app-ds-callout>
    } @else {
      <div data-cy="strategy-summary" class="summary-head">
        <ng-container *ngIf="!mobileView; else mobileSummary">
          <app-strategy-portfolio-summary
            [appLocation]="customer.app_location"
            [investmentData]="investmentData"
            [step]="currentAccount.step_status"
            [language]="customer.language"
          ></app-strategy-portfolio-summary>
        </ng-container>
        <ng-template #mobileSummary>
          <app-strategy-portfolio-summary-mobile
            [appLocation]="customer.app_location"
            [investmentData]="investmentData"
            [step]="currentAccount.step_status"
            [language]="customer.language"
          ></app-strategy-portfolio-summary-mobile>
        </ng-template>
      </div>

      <div>
        <app-setup-portfolio-stocks-bonds
          [appLocation]="customer.app_location"
          [investmentData]="investmentData"
          [step]="currentAccount.step_status"
          [kind]="currentAccount.kind"
          [bonds]="bondList"
        ></app-setup-portfolio-stocks-bonds>
      </div>

      <app-strategy-stock-allocation
        *ngIf="currentAccount?.step_status < 5 || investmentData?.current_amount > 0"
        [customer]="customer"
      ></app-strategy-stock-allocation>

      <ng-container *ngIf="currentAccount?.step_status < 5; else customerGraph">
        <app-strategy-portfolio-estimated-development
          [investmentData]="investmentData"
          [customer]="customer"
        ></app-strategy-portfolio-estimated-development>
      </ng-container>

      <ng-template #customerGraph>
        <div class="portfolio-box">
          <app-savings-analysis
            [customer]="customer"
            [currentAccount]="currentAccount"
            [customerInvestment]="investmentData"
            [hideSavingsPlan]="true"
          ></app-savings-analysis>
        </div>
      </ng-template>

      <ng-container *ngIf="currentAccount?.step_status < 5">
        <app-strategy-portfolio-fees
          [investmentData]="investmentData"
          [customer]="customer"
          [currentAccount]="currentAccount"
        ></app-strategy-portfolio-fees>
        <app-strategy-portfolio-customer-support
          [totalFee]="currentAccount.inyova_fee"
        ></app-strategy-portfolio-customer-support>
      </ng-container>
    }
  </ng-container>
  <ng-template #loadingState>
    <app-loading-spinner class="loading-spinner"></app-loading-spinner>
  </ng-template>
</div>

<app-footer>
  <ng-container *ngIf="currentAccount.step_status !== 5">
    <button
      *ngIf="(flipperBookConsultation$ | async)?.attributes?.value && currentAccount.step_status === 2"
      (click)="bookModal(true)"
      class="ui-button secondary"
    >
      {{ 'cta_book_consultation' | translate }}
    </button>
    <button (click)="navigateTo()" [disabled]="CTALoading" class="ui-button attention" [ngClass]="{ loading: CTALoading }">
      <span class="icon-i-windmill"></span>{{ getCTA() | translate }}
    </button>
  </ng-container>
  <ng-container *ngIf="currentAccount.step_status === 5">
    @if (isEditMode && strategyWasChanged) {
      <button (click)="discardStrategy()" class="ui-button secondary" [disabled]="isSavingStrategyChangesEve2$ | async">
        {{ 'new_strategy.portfolio_screen.edit_mode.discard' | translate }}
      </button>
      <button
        (click)="saveStrategy()"
        class="ui-button"
        [class.loading]="isSavingStrategyChangesEve2$ | async"
        [disabled]="isSavingStrategyChangesEve2$ | async"
      >
        {{ 'new_strategy.portfolio_screen.edit_mode.save' | translate }}
      </button>
    } @else if (isEditMode && !strategyWasChanged) {
      <button (click)="discardStrategy()" class="ui-button">
        {{ 'new_strategy.portfolio_screen.back_cta' | translate }}
      </button>
    } @else {
      <button (click)="changeStrategy()" class="ui-button secondary" [disabled]="isChangeStrategyDisabled$ | async">
        {{ 'cta_change' | translate }}
      </button>
      <button [routerLink]="'/adjust-investment'" class="ui-button">
        {{ 'reinvest.savings_cta' | translate }}
      </button>
    }
  </ng-container>
</app-footer>

<button
  class="ui-button-text back-to-top"
  [ngClass]="{
    active: showScroll === true,
    'align-lower': currentAccount.step_status === 3 || currentAccount.step_status === 4
  }"
  (click)="scrollTop()"
>
  <span>{{ 'strategy.portfolio.backToTop' | translate }}</span>
  <span class="icon-i-chevron-up"></span>
</button>

<app-dialog-book-consultation
  *ngIf="bookConsultation"
  (bookModal)="bookModal($event)"
  [appLocation]="customer.app_location"
  [accountId]="currentAccount.id"
></app-dialog-book-consultation>

